import { m } from "framer-motion";

const fade = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.25 },
};

export default function Contact() {
  return (
    <m.main
      {...fade}
      className="min-h-screen px-6 py-16 flex items-center justify-center"
    >
      <div className="w-full max-w-xl text-center">
        <h1 className="text-3xl font-bold tracking-tight text-slate-900 mb-6">
          Contact
        </h1>

        <address className="not-italic text-slate-700 text-lg leading-relaxed">
          <p className="font-semibold">OPERATIONS HOLDING INC</p>
          <p>481 8th Avenue</p>
          <p>Suite 1121</p>
          <p>New York, NY 10001</p>
        </address>

        {/* Optional: open in Google Maps */}
        <div className="mt-6">
          <a
            href="https://maps.google.com/?q=481%208th%20Avenue%20Suite%201121%20New%20York%2C%20NY%2010001"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 underline"
          >
            Open in Maps
          </a>
        </div>
      </div>
    </m.main>
  );
}
